var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-tree"
    },
    [
      _c(
        "ul",
        {
          staticClass: "cw-tree-root-list"
        },
        [
          _c("courseware-tree-item", {
            staticClass: "cw-tree-item",
            attrs: {
              element: _vm.rootElement,
              currentElement: _vm.currentElement
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }